import React, { useState } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Collapse from "@mui/material/Collapse";
import { ColDataType, RowDataType } from "./types";

interface RowComponentProps {
  row: RowDataType;
  columns: ColDataType[];
  tablePrefixClass?: string;
}

export function Row({ row, columns, tablePrefixClass }: RowComponentProps) {
  const [open, setOpen] = useState(false);

  const expandable = row.options?.expandableEl !== undefined ? true : false;
  const expandCtrlColIndex =
    expandable && row.options?.expandCtrlColIndex !== undefined
      ? row.options.expandCtrlColIndex
      : 0;

  return (
    <>
      <TableRow
        hover={row.options?.hoverDisabled ? false : true}
        tabIndex={-1}
        className={`${tablePrefixClass ?? ""} table__body__row ${
          row.options?.className ?? ""
        } ${expandable ? "table__body__row--expandable" : ""} ${
          open ? "table__body__row--expandable--open" : ""
        }`}
      >
        {columns.map((column, index) => {
          const value = row[column.id];

          if (!row.options?.renderCellsWhenUndefined && value === undefined)
            return;

          return (
            <TableCell
              key={column.id}
              align={column.align ?? "left"}
              colSpan={row.options?.colSpan ?? 1}
            >
              {value}
              {expandable && index === expandCtrlColIndex && (
                <div
                  className={`${
                    tablePrefixClass ?? ""
                  } table__body__row__expand ${
                    open
                      ? "table__body__row__expand--open"
                      : "table__body__row__expand--closed"
                  }`}
                  onClick={() => setOpen(!open)}
                >
                  {row.options?.expandCtrlEl ?? <span>Expand</span>}
                </div>
              )}
            </TableCell>
          );
        })}
      </TableRow>
      {expandable && (
        <TableRow
          className={`${
            tablePrefixClass ?? ""
          } table__body__row__expandable-container`}
        >
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, borderBottom: "unset" }}
            colSpan={columns.length}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              {row.options?.expandableEl}
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
